import {
  ActionIcon,
  Badge,
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Loader,
  LoadingOverlay,
  rem,
  Select,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconBuildingWarehouse,
  IconCalendarDown,
  IconCalendarUp,
  IconFileExport,
  IconFileSearch,
  IconNumbers,
  IconSearch,
  IconTimeDuration15,
  IconTruckDelivery,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { repositoryPos } from "../../../_base/_const/_constVar";
import BreadcrumbLayout1 from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { isJSON } from "../../../_base/helper/FunctionHelper";
import { paginationBase } from "../../../_base/model/_base/BaseTable";
import {
  formatDateNotTimeZone,
  formatDateTransfer,
} from "../../../common/FormatDate/FormatDate";
import { BASE_API_POS } from "../../../config";
import { green, olive_green, sky_blue } from "../../../const/variables";
import { MessageResponse } from "../../../model/MessageResponse";
import { getMasterOrgSelect } from "../../../service/getSelectApi";
import ConfirmInfoAhamove from "./ConfirmInfoAhamove";
import { useTableFillScreen } from "./useTableFillScreen";
import {
  getShippingVendorText,
  getTextStatus,
  warehouseStatus,
} from "./helper";
import * as XLSX from "xlsx";
import PushAhamoveOrder from "./PushAhamoveOrder";

// Định nghĩa kiểu dữ liệu đơn hàng đối tác
interface AhamoveOrder {
  orderCode: string; // Mã đơn hàng nội bộ
  partnerOrderCode: string; // Mã đơn bên đối tác
}

// Định nghĩa đúng kiểu dữ liệu
type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const Ahamove = () => {
  const navigate = useNavigate();
  const [data, setData] = useState<AhamoveOrder[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState(paginationBase);
  const [rowCount, setRowCount] = useState(0);
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const [visible, { toggle, open, close }] = useDisclosure(false);
  //dataExportExcel
  const [dataExportExcel, setDataExportExcel] = useState<any[]>([]);
  // Đổi giá trị để tải lại danh sách sau khi đẩy đơn Ahamove
  const [reload, setReload] = useState<boolean>(false);
  // Thông báo hiện sau khi tải lại xong (repositoryPos.get xoá hết thông báo khi bắt đầu gọi)
  const reloadMessageRef = useRef<string | null>(null);
  // Hàm xem chi tiết đơn hàng
  const handleCheckView = React.useCallback(
    async (row: any) => {
      const url = `/api/v1/CreateSellItem/details?orderNumber=${row.original.orderNumber}`;
      const response = await repositoryPos.get<MessageResponse<any>>(url);
      if (response && response.success) {
        // Kiểm tra nếu orderNumber chứa "DT"
        if (row.original.orderNumber.includes("DT")) {
          navigate("/sell/view-order-return", {
            state: {
              id: row.original.id,
              orderNumber: row.original.orderNumber,
              orderType: row.original.orderType,
              actionType: "view",
              // isReadOnly:
              //   location?.pathname === "/sell/sales-order-list-read-only"
              //     ? true
              //     : false,
            },
          });
        } else {
          navigate("/sell/view-order", {
            state: {
              id: row.original.id,
              orderNumber: row.original.orderNumber,
              orderType: row.original.orderType,
              actionType: "view",
              // isReadOnly:
              //   location?.pathname === "/sell/sales-order-list-read-only"
              //     ? true
              //     : false,
            },
          });
        }
      }
    },
    [navigate],
  );

  // Hàm gọi API lấy danh sách đơn hàng đối tác
  const fetchData = async (exportExcel?: boolean) => {
    setIsLoading(true);
    try {
      const {
        KeySearch,
        OrderNumber,
        Phone,
        FinishDate,
        StartDate,
        EndDate,
        OrgId,
      } = searchForm.values;
      let url = `/api/v1/CreateSellItem/get-list-return-sale?Skip=${
        pagination.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}&ShipingVendor=Ahamove`;
      const params: string[] = [];
      if (KeySearch) params.push(`KeySearch=${encodeURIComponent(KeySearch)}`);
      if (OrderNumber)
        params.push(`OrderNumber=${encodeURIComponent(OrderNumber)}`);
      if (Phone) params.push(`Phone=${encodeURIComponent(Phone)}`);
      if (FinishDate)
        params.push(`FinishDate=${FinishDate.toISOString().slice(0, 10)}`);
      if (StartDate) params.push(`StartDate=${StartDate}`);
      if (EndDate) params.push(`EndDate=${EndDate}`);
      if (OrgId) params.push(`OrgId=${OrgId}`);
      // Sửa lỗi lệch ngày khi tìm kiếm ngày xuất kho
      if (filterOwDate) {
        const localDate = `${filterOwDate.getFullYear()}-${(
          filterOwDate.getMonth() + 1
        )
          .toString()
          .padStart(2, "0")}-${filterOwDate
          .getDate()
          .toString()
          .padStart(2, "0")}`;
        params.push(`OwDate=${localDate}`);
      }
      if (filterOrderStatus) params.push(`OrderStatus=${filterOrderStatus}`);
      if (filterDeliveryStatus)
        params.push(`Attribute64=${filterDeliveryStatus}`);
      if (filterAttribute12) params.push(`Attribute12=${filterAttribute12}`);
      if (params.length > 0) {
        url += "&" + params.join("&");
      }
      const response = await repositoryPos.get<MessageResponse<any>>(url);
      if (response && response.success) {
        setData(response.data?.pagedList?.lists || []);
        setRowCount(response.totalCount);

        if (exportExcel && !response?.totalCount) {
          NotificationExtension.Fails(
            "Export Excel thất bại, vui lòng liên hệ phòng CNTT !",
          );
        } else if (exportExcel && response?.totalCount > 0) {
          handleExport(response?.totalCount);
        }
      } else {
        setData([]);
        setRowCount(0);
      }
    } catch (error) {
      setData([]);
      setRowCount(0);
      console.error("Error fetching Ahamove orders:", error);
    } finally {
      setIsLoading(false);
      if (reloadMessageRef.current) {
        NotificationExtension.Success(reloadMessageRef.current);
        reloadMessageRef.current = null;
      }
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...searchForm.getValues(),
          filterOwDate: filterOwDate,
          filterAttribute12: filterAttribute12,
          filterDeliveryStatus: filterDeliveryStatus,
          filterOrderStatus: filterOrderStatus,
        }),
      );
    }
  };

  const handleExport = async (totalCount: number) => {
    open();
    try {
      const {
        KeySearch,
        OrderNumber,
        Phone,
        FinishDate,
        StartDate,
        EndDate,
        OrgId,
      } = searchForm.values;
      let url = `/api/v1/CreateSellItem/get-list-return-sale?Skip=0&Take=${totalCount}&ShipingVendor=Ahamove`;
      const params: string[] = [];
      if (KeySearch) params.push(`KeySearch=${encodeURIComponent(KeySearch)}`);
      if (OrderNumber)
        params.push(`OrderNumber=${encodeURIComponent(OrderNumber)}`);
      if (Phone) params.push(`Phone=${encodeURIComponent(Phone)}`);
      if (FinishDate)
        params.push(`FinishDate=${FinishDate.toISOString().slice(0, 10)}`);
      if (StartDate) params.push(`StartDate=${StartDate}`);
      if (EndDate) params.push(`EndDate=${EndDate}`);
      if (OrgId) params.push(`OrgId=${OrgId}`);
      // Sửa lỗi lệch ngày khi tìm kiếm ngày xuất kho
      if (filterOwDate) {
        const localDate = `${filterOwDate.getFullYear()}-${(
          filterOwDate.getMonth() + 1
        )
          .toString()
          .padStart(2, "0")}-${filterOwDate
          .getDate()
          .toString()
          .padStart(2, "0")}`;
        params.push(`OwDate=${localDate}`);
      }
      if (filterOrderStatus) params.push(`OrderStatus=${filterOrderStatus}`);
      if (filterDeliveryStatus)
        params.push(`Attribute64=${filterDeliveryStatus}`);
      if (filterAttribute12) params.push(`Attribute12=${filterAttribute12}`);
      if (params.length > 0) {
        url += "&" + params.join("&");
      }
      const response = await repositoryPos.get<MessageResponse<any>>(url);
      if (response && response.success) {
        const dataAPI = response.data?.pagedList?.lists || [];
        const dataExport = dataAPI.map((i: any) => ({
          "Mã đơn hàng": i.orderNumber || "",
          "Trạng thái đơn hàng":
            orderStatusOptions.find((item) => item.value === i.orderStatus)
              ?.label ||
            i.orderStatus ||
            "",
          "Trạng thái chung": i.attribute12 || "",
          // Có link Ahamove là đã đẩy, kể cả đơn chưa xuất kho
          "Trạng thái đẩy đơn":
            i.attribute1 &&
            isJSON(i.attribute1) &&
            JSON.parse(i.attribute1)?.sharedLink
              ? "Đã đẩy"
              : i.attribute3 !== "DA_XUAT"
                ? "Chưa đẩy"
                : "Không xác định",
          "Trạng thái giao hàng":
            i.attribute64 === "ASSIGNING"
              ? "Đang tìm tài xế"
              : i.attribute64 === "ACCEPTED"
                ? "Đã nhận đơn"
                : i.attribute64 === "IN PROCESS"
                  ? "Đang giao"
                  : i.attribute64 === "COMPLETED"
                    ? "Hoàn thành"
                    : i.attribute64 === "CANCELLED"
                      ? "Bị hủy"
                      : "Không xác định",
          "Trạng thái kho":
            warehouseStatus.find((item) => item.value === i.attribute3)
              ?.label || "Chưa yêu cầu",
          "Ngày xuất kho": i.attribute37
            ? formatDateTransfer(i.attribute37)
            : "",
          "Kho hàng": `[${i.invOrgCode}] ${i.invOrgName}` || "",
          "Nhân viên bán hàng": i.sale || "",
          "Bộ phận giao hàng": i.shipingVendor || "",
        }));

        const worksheet = XLSX.utils.json_to_sheet(dataExport);

        const objectMaxLength: any[] = [];
        dataExport.forEach((row: any) => {
          Object.keys(row).forEach((key, index) => {
            const headerLen = key ? key.toString().length : 0;
            const valueLen = row[key] ? row[key].toString().length : 0;
            const maxLen = Math.max(headerLen, valueLen);

            objectMaxLength[index] = Math.max(
              objectMaxLength[index] || 0,
              maxLen,
            );
          });
        });

        worksheet["!cols"] = objectMaxLength.map((w) => ({ wch: w + 5 }));

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Báo cáo Ahamove");
        XLSX.writeFile(workbook, "Bao_cao_Ahamove.xlsx");
      }
    } catch (error) {
      console.error("Error fetching Ahamove orders:", error);
    } finally {
      close();
    }
  };

  // const handleExport = async () => {
  //   open();
  //   try {
  //     const {
  //       KeySearch,
  //       OrderNumber,
  //       Phone,
  //       FinishDate,
  //       StartDate,
  //       EndDate,
  //       OrgId,
  //     } = searchForm.values;
  //     let url = `/api/v1/CreateSellItem/export-sale-order?Skip=${
  //       pagination.pageIndex * pagination.pageSize
  //     }&Take=${pagination.pageSize}&ShipingVendor=Ahamove`;
  //     const params: string[] = [];
  //     if (KeySearch) params.push(`KeySearch=${encodeURIComponent(KeySearch)}`);
  //     if (OrderNumber)
  //       params.push(`OrderNumber=${encodeURIComponent(OrderNumber)}`);
  //     if (Phone) params.push(`Phone=${encodeURIComponent(Phone)}`);
  //     if (FinishDate)
  //       params.push(`FinishDate=${FinishDate.toISOString().slice(0, 10)}`);
  //     if (StartDate) params.push(`StartDate=${StartDate}`);
  //     if (EndDate) params.push(`EndDate=${EndDate}`);
  //     if (OrgId) params.push(`OrgId=${OrgId}`);
  //     // Sửa lỗi lệch ngày khi tìm kiếm ngày xuất kho
  //     if (filterOwDate) {
  //       const localDate = `${filterOwDate.getFullYear()}-${(
  //         filterOwDate.getMonth() + 1
  //       )
  //         .toString()
  //         .padStart(2, "0")}-${filterOwDate
  //         .getDate()
  //         .toString()
  //         .padStart(2, "0")}`;
  //       params.push(`OwDate=${localDate}`);
  //     }
  //     if (filterOrderStatus) params.push(`OrderStatus=${filterOrderStatus}`);
  //     if (filterDeliveryStatus)
  //       params.push(`Attribute64=${filterDeliveryStatus}`);
  //     if (filterAttribute12) params.push(`Attribute12=${filterAttribute12}`);
  //     if (params.length > 0) {
  //       url += "&" + params.join("&");
  //     }

  //     const _url = BASE_API_POS + url;
  //     const token = localStorage.getItem("token");

  //     const response = await fetch(_url, {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/vnd.ms-excel",
  //         Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
  //       },
  //     });

  //     if (!response.ok) {
  //       NotificationExtension.Fails("Export Excel thất bại !");
  //     } else {
  //       const blob = await response.blob();
  //       const urlss = window.URL.createObjectURL(blob);
  //       const _name = new Date().toISOString().slice(0, 10);
  //       let filename = "bao_cao_ahamove.xlsx";
  //       const link = document.createElement("a");
  //       link.href = urlss;
  //       link.download = filename;
  //       document.body.appendChild(link);
  //       link.click();
  //       link.remove();
  //       window.URL.revokeObjectURL(url);
  //       NotificationExtension.Success("Export Excel thành công !");
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     close();
  //   }
  // };

  const getDataBranch = async () => {
    const res = await getMasterOrgSelect();

    if (res) {
      const data = res
        .filter((i) => i.value && i.text)
        .map((i) => ({
          label: `${i.att1} - ${i.text}`,
          value: String(i.value),
        }));

      setDataBranch(data);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.pageIndex, pagination.pageSize, reload]);

  useEffect(() => {
    Promise.all([getDataBranch()]);
  }, []);

  // Định nghĩa columns cho MantineReactTable
  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 50,
        enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        enableColumnFilters: false,
      },
      {
        accessorKey: "orderNumber",
        header: "Mã đơn hàng",
        // // enableColumnActions: false,,
        enableColumnFilter: false,
        size: 160,
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip label="Xem chi tiết">
            <Badge
              radius="sm"
              variant="dot"
              size="md"
              style={{ cursor: "pointer" }}
              color={renderedCellValue === null ? "red" : green.base}
              onDoubleClick={() => handleCheckView(row)}
            >
              {renderedCellValue === null ? "KHÔNG HỢP LỆ" : renderedCellValue}
            </Badge>
          </Tooltip>
        ),
      },
      {
        accessorKey: "orderStatus",
        header: "Trạng thái đơn hàng",
        // // enableColumnActions: false,,
        enableColumnFilter: false,
        size: 200,
        Cell: ({ row }) => {
          const orderStatus = row.original.orderStatus;
          let badgeColor;
          switch (orderStatus) {
            case "DON_HANG_TAM":
              badgeColor = "cyan";
              break;
            case "DON_HANG_CHOT":
              badgeColor = "violet";
              break;
            case "DON_HANG_DOI_TRA_TAM":
              badgeColor = "cyan";
              break;
            case "DON_HANG_HOAN_THANH":
              badgeColor = "green";
              break;
            case "DON_HANG_DOI_TRA":
              badgeColor = "green";
              break;
            case "THANH_TOAN_CHUA_HOAN_THANH":
              badgeColor = "red";
              break;
            case "pending":
              badgeColor = "yellow";
              break;
            case "DON_HANG_BAN_TAI_SHOP":
              badgeColor = "green";
              break;
            case "DON_HANG_CHO_DUYET_GIAM":
              badgeColor = olive_green.light;
              break;
            case "DON_HANG_DA_DUYET_GIAM":
              badgeColor = olive_green.medium;
              break;
            case "KHO_XUAT_HANG":
              badgeColor = sky_blue.medium;
              break;
            case "DON_HANG_DONG":
              badgeColor = "red";
              break;
            default:
              badgeColor = "gray";
          }
          return (
            <Badge
              size="md"
              color={badgeColor}
              fs={"12,5px"}
              fw={"bold"}
              radius="sm"
            >
              {row.original.orderStatus !== null
                ? getTextStatus(row)
                : "Không HỢP LỆ"}
            </Badge>
          );
        },
      },
      {
        accessorKey: "attribute12",
        header: "Trạng thái chung",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        // accessorKey: "attribute12",
        accessorKey: "pushStatus",
        header: "Trạng thái đẩy đơn",
        Cell: ({ row }) => {
          // Có link Ahamove là đã đẩy, kể cả đơn chưa xuất kho
          const attr1Push = row?.original?.attribute1;
          if (
            attr1Push &&
            isJSON(attr1Push) &&
            JSON.parse(attr1Push)?.sharedLink
          ) {
            return (
              <Badge color="green" variant="light">
                Đã đẩy
              </Badge>
            );
          }
          if (row?.original?.attribute3 === "DA_XUAT") {
            try {
              const attr1 = row?.original?.attribute1;
              if (attr1) {
                const data = JSON.parse(attr1);
                if (data.sharedLink) {
                  return (
                    <Flex align="center" gap={8}>
                      <Badge color="green" variant="light">
                        Đã đẩy
                      </Badge>
                    </Flex>
                  );
                } else {
                  // Đẩy đơn lỗi: màu đỏ
                  return (
                    <Badge color="red" variant="light">
                      Đẩy đơn lỗi
                    </Badge>
                  );
                }
              }
            } catch (e) {
              // Đẩy đơn lỗi: màu đỏ
              return (
                <Badge color="red" variant="light">
                  Đẩy đơn lỗi
                </Badge>
              );
            }
          }
          // Chưa đẩy: màu xám
          return (
            <Badge color="gray" variant="light">
              Chưa đẩy
            </Badge>
          );
        },
      },
      {
        accessorKey: "attribute64",
        header: "Trạng thái giao hàng",
        enableColumnActions: false,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          const getDeliveryStatusText = (status: string) => {
            switch (status) {
              case "ASSIGNING":
                return "Đang tìm tài xế";
              case "ACCEPTED":
                return "Đã nhận đơn";
              case "IN PROCESS":
                return "Đang giao";
              case "COMPLETED":
                return "Hoàn thành";
              case "CANCELLED":
                return "Bị hủy";
              default:
                return "Không xác định";
            }
          };

          const getDeliveryStatusColor = (status: string) => {
            switch (status) {
              case "ASSIGNING":
                return "yellow";
              case "ACCEPTED":
                return "blue";
              case "IN PROCESS":
                return "orange";
              case "COMPLETED":
                return "green";
              case "CANCELLED":
                return "red";
              default:
                return "gray";
            }
          };

          try {
            // Lấy giá trị từ attribute64 thay vì deliveryStatus trong attribute1
            const attribute64 = row?.original?.attribute64;
            if (attribute64) {
              return (
                <Badge
                  color={getDeliveryStatusColor(attribute64)}
                  variant="light"
                >
                  {getDeliveryStatusText(attribute64)}
                </Badge>
              );
            }
            return (
              <Badge color="gray" variant="light">
                Không xác định
              </Badge>
            );
          } catch (e) {
            return (
              <Badge color="gray" variant="light">
                Không xác định
              </Badge>
            );
          }
        },
      },
      {
        accessorKey: "attribute3",
        header: "Trạng thái kho",
        Cell: ({ renderedCellValue, row }) => {
          const _status = warehouseStatus.find(
            (status) => status.value === row?.original?.attribute3?.toString(),
          );

          return (
            <Badge size="sm" color="cyan">
              {_status?.label ? _status.label : "Chưa yêu cầu"}
            </Badge>
          );
        },
      },
      {
        accessorKey: "attribute37",
        header: "Ngày xuất kho",
        Cell: ({ renderedCellValue }: any) => {
          if (
            typeof renderedCellValue === "string" ||
            renderedCellValue instanceof Date
          ) {
            return <>{formatDateTransfer(renderedCellValue)}</>;
          }
          return <>{formatDateTransfer(undefined)}</>;
        },
      },

      {
        accessorKey: "invOrgName",
        header: "Kho hàng",
        // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ row, column }) => (
          <>{`[${row.original.invOrgCode}] ${row.original.invOrgName}`}</>
        ),
      },
      {
        accessorKey: "sale",
        header: "Nhân viên bán hàng",
        size: 180,
        enableColumnFilter: false,
      },
      {
        accessorKey: "shipingVendor",
        header: "Bộ phận giao hàng",
        // // enableColumnActions: false,,
        enableColumnFilter: false,
        Cell: ({ row, column }) => (
          <>{getShippingVendorText(row?.original?.shipingVendor ?? "")}</>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        size: 120,
        enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        enableColumnFilters: false,
        enableColumnFilter: false,
        Cell: ({ row }) => {
          const actions = [];
          const attr1 = row.original.attribute1 || null;
          const sharedLink =
            row.original.attribute1 && isJSON(row.original.attribute1)
              ? JSON.parse(attr1)?.sharedLink
              : null;

          if (
            (row?.original?.shipingVendor === "Ahamove" ||
              row?.original?.shipingVendor === "Ahamove Siêu tốc" ||
              row?.original?.shipingVendor === "Ahamove Siêu tốc tiết kiệm") &&
            row?.original?.orderStatus === "DON_HANG_HOAN_THANH" &&
            // Đơn đang tìm tài xế thì không cho đẩy
            row.original.attribute64 !== "ASSIGNING" &&
            // Đã có link Ahamove thì ẩn nút (kể cả đơn chưa xuất kho), trừ đơn bị hủy
            (!sharedLink || row.original.attribute64 === "CANCELLED")
          ) {
            actions.push(
              <Tooltip label="Đẩy lại Ahamove" key="push-ahamove">
                <ActionIcon
                  // Code cũ (FE tự dựng địa chỉ, gọi thẳng Ahamove):
                  // onClick={() => modalsConfirmInfo(row.original.orderNumber)}
                  onClick={() => modalsPushAhamoveOrder(row.original)}
                  variant="light"
                  aria-label="Settings"
                  color="green"
                >
                  <IconTruckDelivery size={20} stroke={1.5} />
                </ActionIcon>
              </Tooltip>,
            );
          }
          // Thông tin giao vận (icon link)
          try {
            const attr1 = row?.original?.attribute1;
            if (attr1) {
              const data = JSON.parse(attr1);
              if (data.sharedLink) {
                actions.push(
                  <Tooltip label="Thông tin giao vận" key="tracking-link">
                    <ActionIcon
                      color="blue"
                      variant="light"
                      onClick={() => {
                        window.open(`${data.sharedLink}`, "_blank");
                      }}
                      aria-label="Thông tin giao vận"
                    >
                      <IconFileExport size={20} stroke={1.5} />
                    </ActionIcon>
                  </Tooltip>,
                );
              }
            }
          } catch (e) {}
          return <Flex gap={10}>{actions}</Flex>;
        },
      },
    ],
    [handleCheckView],
  );

  const modalsConfirmInfo = (orderNumber: string) => {
    modals.openConfirmModal({
      title: <Title order={5}>Xác nhận thông tin !</Title>,
      size: "auto",
      children: (
        <ConfirmInfoAhamove orderNumber={orderNumber} onSuccess={fetchData} />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  // Đẩy đơn qua API BE /api/v1/Ahamove/push-order (thay cho modalsConfirmInfo)
  const modalsPushAhamoveOrder = (order: any) => {
    const attr1 =
      order.attribute1 && isJSON(order.attribute1)
        ? JSON.parse(order.attribute1)
        : null;

    modals.openConfirmModal({
      title: <Title order={5}>Đẩy đơn Ahamove</Title>,
      size: 460,
      children: (
        <PushAhamoveOrder
          orderNumber={order.orderNumber}
          customerName={attr1?.customerName}
          phone={attr1?.telephoneNumber}
          branch={
            order.invOrgName
              ? `[${order.invOrgCode}] ${order.invOrgName}`
              : undefined
          }
          shippingVendor={order.shipingVendor}
          typeShip={attr1?.typeShip}
          existingAhamove={attr1?.sharedLink || attr1?.ahamoveOrderId}
          onSuccess={(message) => {
            reloadMessageRef.current = message ?? null;
            setReload((prev) => !prev);
          }}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  // Lưu ghim cột - Function để lấy cấu hình từ localStorage
  const getColumnPinningStorage = () => {
    try {
      const columnPinningStorage = localStorage.getItem("ahamoveColumnPinning");
      return columnPinningStorage
        ? JSON.parse(columnPinningStorage)
        : { left: ["STT", "orderNumber"], right: ["action"] }; // Giá trị mặc định
    } catch (error) {
      console.error("Error parsing column pinning storage:", error);
      return { left: ["STT", "orderNumber"], right: ["action"] };
    }
  };

  // State cho columnPinning - khởi tạo từ localStorage
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(() =>
    getColumnPinningStorage(),
  );

  // Effect để lưu columnPinning vào localStorage mỗi khi có thay đổi
  useEffect(() => {
    try {
      localStorage.setItem(
        "ahamoveColumnPinning",
        JSON.stringify(columnPinning),
      );
    } catch (error) {
      console.error("Error saving column pinning to localStorage:", error);
    }
  }, [columnPinning]);

  // Chiều cao vùng cuộn của bảng, để chân bảng sát đáy màn hình
  const [tableHeight, setTableHeight] = useState<number>();

  const table = useMantineReactTable({
    columns,
    data: data || [],
    enableColumnResizing: true,
    enableTopToolbar: false,
    enableRowSelection: false,
    enableColumnFilters: false,
    enableSorting: false,
    enableColumnActions: false,
    enableStickyHeader: true,
    manualPagination: true,
    rowCount,
    onPaginationChange: setPagination,
    onColumnPinningChange: setColumnPinning,
    // Thiết lập initialState để đảm bảo columnPinning được áp dụng ngay từ đầu
    initialState: {
      columnPinning: {
        ...columnPinning,
      },
    },
    mantineTableProps: {
      striped: true,
      highlightOnHover: true,
      withTableBorder: true,
    },
    mantineTableContainerProps: {
      style: {
        maxHeight: tableHeight,
        minHeight: tableHeight,
        overflowX: "auto",
        overflowY: "auto",
      },
    },
    state: {
      isLoading,
      pagination,
      columnPinning,
    },
    enableColumnPinning: true,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["25", "50"],
    },
    paginationDisplayMode: "pages",
  });
  useTableFillScreen(table, setTableHeight);

  const sizeGrid = { base: 6, sm: 4, md: 3, lg: 3, xl: 2 };
  const searchForm = useForm({
    initialValues: {
      KeySearch: _searchJson && checkedPinSearch ? _searchJson?.KeySearch : "",
      OrderNumber:
        _searchJson && checkedPinSearch ? _searchJson?.OrderNumber : "",
      Phone: _searchJson && checkedPinSearch ? _searchJson?.Phone : "",
      FinishDate:
        _searchJson && checkedPinSearch
          ? _searchJson?.FinishDate
          : (null as Date | null),
      StartDate:
        _searchJson && checkedPinSearch
          ? _searchJson?.StartDate
          : new Date(
              new Date(
                new Date().setMonth(new Date().getMonth() - 1),
              ).getTime() +
                7 * 60 * 60 * 1000,
            )?.toISOString(),
      EndDate:
        _searchJson && checkedPinSearch
          ? _searchJson?.EndDate
          : new Date(new Date().getTime() + 7 * 60 * 60 * 1000)?.toISOString(),
      OrgId: _searchJson && checkedPinSearch ? _searchJson?.OrgId : "",
    },
  });

  // Thêm state cho filter ngày xuất kho và trạng thái đơn hàng
  const [filterOwDate, setFilterOwDate] = useState<Date | null>(
    _searchJson && checkedPinSearch ? _searchJson?.filterOwDate : null,
  );
  const [filterOrderStatus, setFilterOrderStatus] = useState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.filterOrderStatus : "",
  );
  const [filterDeliveryStatus, setFilterDeliveryStatus] = useState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.filterDeliveryStatus : "",
  );
  const [filterAttribute12, setFilterAttribute12] = useState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.filterAttribute12 : "",
  );

  const [dataBranch, setDataBranch] = useState<ComboboxItem[]>([]);

  // Danh sách trạng thái đơn hàng mẫu
  const orderStatusOptions = [
    { value: "", label: "Trạng thái đơn hàng" },
    { value: "DON_HANG_TAM", label: "Đơn hàng tạm" },
    { value: "DON_HANG_CHOT", label: "Đơn hàng chốt" },
    { value: "DON_HANG_HOAN_THANH", label: "Đơn hàng hoàn thành" },
    { value: "DON_HANG_DONG", label: "Đơn hàng đóng" },
    // ...bổ sung thêm nếu cần
  ];

  // Danh sách trạng thái giao hàng
  const deliveryStatusOptions = [
    { value: "", label: "Trạng thái giao hàng" },
    { value: "ASSIGNING", label: "Đang tìm tài xế" },
    { value: "ACCEPTED", label: "Đã nhận đơn" },
    { value: "IN PROCESS", label: "Đang giao" },
    { value: "COMPLETED", label: "Hoàn thành" },
    { value: "CANCELLED", label: "Bị hủy" },
  ];

  // Danh sách trạng thái chung
  const attribute12Options = [
    { value: "", label: "Trạng thái chung" },
    { value: "KHO_XUAT_HANG", label: "Kho xuất hàng" },
    { value: "THANH_CONG", label: "Thành công" },
    { value: "TEST_OK", label: "Test OK" },
    { value: "DON_HANG_HOAN_THANH", label: "Đơn hàng hoàn thành" },
    { value: "DON_HANG_TAM", label: "Đơn hàng tạm" },
    { value: "THAT_BAI_DO_KH", label: "Thất bại do khách hàng" },
    { value: "KTKT_DANG_KIEM_TRA", label: "KTKT đang kiểm tra" },
    { value: "DON_HANG_CHO_DUYET_GIAM", label: "Đơn hàng chờ duyệt giảm" },
    { value: "GV_THANH_CONG", label: "Giao vận thành công" },
    { value: "NHAP_LAI", label: "Nhập lại" },
    { value: "DA_PHAN_CONG_GV", label: "Đã phân công giao vận" },
    { value: "GV_DEN_NOI", label: "Giao vận đến nơi" },
    { value: "GV_DANG_GIAO", label: "Giao vận đang giao" },
    { value: "TEST_LOI", label: "Test lỗi" },
    { value: "DA_PHAN_CONG_KTKT", label: "Đã phân công KTKT" },
    { value: "HUY_PHAN_CONG_GV", label: "Hủy phân công giao vận" },
    { value: "THAT_BAI_DO_HACOM", label: "Thất bại do Hacom" },
    { value: "NHAP_LAI_MOT_PHAN", label: "Nhập lại một phần" },
    { value: "DON_HANG_CHOT", label: "Đơn hàng chốt" },
    { value: "DON_HANG_DA_DUYET_GIAM", label: "Đơn hàng đã duyệt giảm" },
    { value: "GV_TIEP_NHAN", label: "Giao vận tiếp nhận" },
    { value: "GV_NHAP_LAI", label: "Giao vận nhập lại" },
    { value: "GV_NHAP_LAI_MOT_PHAN", label: "Giao vận nhập lại một phần" },
    { value: "GV_THAT_BAI_DO_HACOM", label: "Giao vận thất bại do Hacom" },
    { value: "GV_THAT_BAI_DO_KH", label: "Giao vận thất bại do khách hàng" },
    { value: "GV_NOI_CHUYEN", label: "Giao vận nội chuyển" },
    { value: "HUY_PHAN_CONG_KTKT", label: "Hủy phân công KTKT" },
  ];

  const getDeliveryStatusText = (status: string) => {
    switch (status) {
      case "ASSIGNING":
        return "Đang tìm tài xế";
      case "ACCEPTED":
        return "Đã nhận đơn";
      case "IN PROCESS":
        return "Đang giao";
      case "COMPLETED":
        return "Hoàn thành";
      case "CANCELLED":
        return "Bị hủy";
      default:
        return "Không xác định";
    }
  };

  return (
    <Box>
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 5 }}
        loaderProps={{
          children: (
            <Flex direction={"column"} align="center" gap="xs">
              <Loader type="dots" size={35}></Loader>
              {/* <Title size={15}> Đang upload tài liệu...</Title> */}
              <Title size={15}> Đang xử lý....</Title>
            </Flex>
          ),
        }}
      />
      <Flex
        justify="space-between"
        align="center"
        style={{
          border: "1px solid #dee2e6",
          padding: "5px 10px",
        }}
      >
        <BreadcrumbLayout1></BreadcrumbLayout1>
        <Flex gap={"xs"}>
          <Button
            leftSection={<IconFileExport size={16} />}
            onClick={() => fetchData()}
            loading={isLoading}
          >
            Làm mới
          </Button>
          <Button
            leftSection={
              <IconFileExport style={{ width: rem(14), height: rem(14) }} />
            }
            // onClick={() => handleExport()}
            onClick={() => fetchData(true)}
          >
            Export Excel
          </Button>
        </Flex>
      </Flex>
      <Box
        style={{
          border: "1px solid #dee2e6",
          padding: "10px",
          marginBottom: 20,
        }}
      >
        <Grid gutter={8}>
          <Grid.Col span={sizeGrid}>
            <TextInput
              leftSection={<IconSearch color="#15aabf" />}
              placeholder="Từ khoá"
              {...searchForm.getInputProps("KeySearch")}
              onKeyDown={(e) => {
                if (e.key === "Enter") fetchData();
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              leftSection={<IconCalendarUp color="#15aabf" />}
              placeholder="Ngày bắt đầu"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                searchForm.getValues()?.StartDate &&
                searchForm.getValues()?.StartDate.length > 0
                  ? new Date(searchForm.getValues()?.StartDate ?? "")
                  : null
              }
              onChange={(e) =>
                searchForm.setValues((prev) => ({
                  ...prev,
                  StartDate: e ? formatDateNotTimeZone(e ?? "") : "",
                }))
              }
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              leftSection={<IconCalendarDown color="#15aabf" />}
              placeholder="Ngày kết thúc"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                searchForm.getValues()?.EndDate &&
                searchForm.getValues()?.EndDate.length > 0
                  ? new Date(searchForm.getValues()?.EndDate ?? "")
                  : null
              }
              onChange={(e) =>
                searchForm.setValues((prev) => ({
                  ...prev,
                  EndDate: e ? formatDateNotTimeZone(e ?? "") : "",
                }))
              }
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <TextInput
              leftSection={<IconFileSearch color="#15aabf" />}
              placeholder="Mã đơn hàng"
              {...searchForm.getInputProps("OrderNumber")}
              onKeyDown={(e) => {
                if (e.key === "Enter") fetchData();
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <TextInput
              leftSection={<IconNumbers color="#15aabf" />}
              placeholder="Số ĐT khách"
              {...searchForm.getInputProps("Phone")}
              onKeyDown={(e) => {
                if (e.key === "Enter") fetchData();
              }}
            />
          </Grid.Col>
          {/* <Grid.Col span={sizeGrid}>
            <DatePickerInput
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              size="sm"
              placeholder="Thời gian hoàn thành đơn"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              {...searchForm.getInputProps("FinishDate")}
            />
          </Grid.Col> */}
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              size="sm"
              placeholder="Ngày xuất kho"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              value={
                filterOwDate && String(filterOwDate).length > 0
                  ? new Date(filterOwDate)
                  : null
              }
              onChange={setFilterOwDate}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              placeholder="Kho hàng"
              leftSection={<IconBuildingWarehouse color="#15aabf" />}
              data={dataBranch}
              searchable
              clearable
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              {...searchForm.getInputProps("OrgId")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              placeholder="Trạng thái đơn hàng"
              data={orderStatusOptions}
              value={filterOrderStatus}
              onChange={(value) => setFilterOrderStatus(value || "")}
              clearable
              searchable
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              placeholder="Trạng thái giao hàng"
              data={deliveryStatusOptions}
              value={filterDeliveryStatus}
              onChange={(value) => setFilterDeliveryStatus(value || "")}
              clearable
              searchable
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              placeholder="Trạng thái chung"
              data={attribute12Options}
              value={filterAttribute12}
              onChange={(value) => setFilterAttribute12(value || "")}
              clearable
              searchable
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Button
              leftSection={<IconSearch size={14} />}
              color="blue"
              variant="outline"
              onClick={() => fetchData()}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </Box>
      <MantineReactTable table={table} />
    </Box>
  );
};

export default Ahamove;
